// used to mark unsupported tokens, these are hosted lists of unsupported tokens

import { ChainId, CURRENT_CHAIN } from '@hyperswap/addresses'

// TODO github token list
const COMPOUND_LIST =
  (CURRENT_CHAIN as unknown) === ChainId.HYPEREVM_TESTNET
    ? 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-testnet-token-list/refs/heads/main/tokens.json'
    : 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/tokens.json'

export const UNSUPPORTED_LIST_URLS: string[] = []

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [
  COMPOUND_LIST,

  ...UNSUPPORTED_LIST_URLS, // need to load unsupported tokens as well
]

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = [COMPOUND_LIST]
